export const createCsvDataUrl = (csv: string): string => {
  const csvWithBom = '\uFEFF' + csv;
  const encoded = encodeURIComponent(csvWithBom);

  return `data:text/csv;charset=utf-8,${encoded}`;
};
